/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_LoadingInputs */

const id_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membandingkan snapshot manifest…`)
};

const ms_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membandingkan syot kilat manifes…`)
};

const da_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenligner manifestsnapshots…`)
};

const de_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest-Snapshots werden verglichen…`)
};

const en_us2_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparing manifest snapshots…`)
};

const es_es2_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparando los manifiestos…`)
};

const es_mx2_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparando las instantáneas del manifiesto…`)
};

const fil_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inihahambing ang mga snapshot ng manifest…`)
};

const fr_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparaison des instantanés de manifeste…`)
};

const it_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronto degli snapshot del manifest…`)
};

const hu_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest-pillanatképek összehasonlítása…`)
};

const nl_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifestsnapshots vergelijken…`)
};

const no_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenligner manifestøyeblikksbilder…`)
};

const pl_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównywanie zrzutów manifestu…`)
};

const pt_br2_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparando snapshots do manifesto…`)
};

const pt_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A comparar capturas do manifesto…`)
};

const ro_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se compară instantaneele manifestului…`)
};

const fi_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaillaan manifestivedoksia…`)
};

const sv_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jämför manifestögonblicksbilder…`)
};

const vi_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang so sánh các ảnh chụp manifest…`)
};

const tr_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest anlık görüntüleri karşılaştırılıyor…`)
};

const cs_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porovnávání snímků manifestu…`)
};

const bg_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравняване на моментните снимки на манифеста…`)
};

const ru_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнение снимков манифеста…`)
};

const uk_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Порівняння знімків маніфесту…`)
};

const ar_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ مقارنة لقطات البيانات…`)
};

const hi_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेनिफ़ेस्ट स्नैपशॉट की तुलना की जा रही है…`)
};

const th_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังเปรียบเทียบสแนปช็อตแมนิเฟสต์…`)
};

const ja_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マニフェストスナップショットを比較しています…`)
};

const zh_cn2_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在比较清单快照…`)
};

const zh_hant1_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在比較資訊清單快照…`)
};

const ko_builds_comparison_loading = /** @type {(inputs: Builds_Comparison_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매니페스트 스냅샷 비교 중…`)
};

/**
* | output |
* | --- |
* | "Comparing manifest snapshots…" |
*
* @param {Builds_Comparison_LoadingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_loading = /** @type {((inputs?: Builds_Comparison_LoadingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_LoadingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_loading(inputs)
	if (locale === "ms") return ms_builds_comparison_loading(inputs)
	if (locale === "da") return da_builds_comparison_loading(inputs)
	if (locale === "de") return de_builds_comparison_loading(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_loading(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_loading(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_loading(inputs)
	if (locale === "fil") return fil_builds_comparison_loading(inputs)
	if (locale === "fr") return fr_builds_comparison_loading(inputs)
	if (locale === "it") return it_builds_comparison_loading(inputs)
	if (locale === "hu") return hu_builds_comparison_loading(inputs)
	if (locale === "nl") return nl_builds_comparison_loading(inputs)
	if (locale === "no") return no_builds_comparison_loading(inputs)
	if (locale === "pl") return pl_builds_comparison_loading(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_loading(inputs)
	if (locale === "pt") return pt_builds_comparison_loading(inputs)
	if (locale === "ro") return ro_builds_comparison_loading(inputs)
	if (locale === "fi") return fi_builds_comparison_loading(inputs)
	if (locale === "sv") return sv_builds_comparison_loading(inputs)
	if (locale === "vi") return vi_builds_comparison_loading(inputs)
	if (locale === "tr") return tr_builds_comparison_loading(inputs)
	if (locale === "cs") return cs_builds_comparison_loading(inputs)
	if (locale === "bg") return bg_builds_comparison_loading(inputs)
	if (locale === "ru") return ru_builds_comparison_loading(inputs)
	if (locale === "uk") return uk_builds_comparison_loading(inputs)
	if (locale === "ar") return ar_builds_comparison_loading(inputs)
	if (locale === "hi") return hi_builds_comparison_loading(inputs)
	if (locale === "th") return th_builds_comparison_loading(inputs)
	if (locale === "ja") return ja_builds_comparison_loading(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_loading(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_loading(inputs)
	return ko_builds_comparison_loading(inputs)
});
export { builds_comparison_loading as "builds.comparison.loading" }